<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title-p"><span>Praise for the Writing of Margery Sharp</span></p>
<p class="normal1">“A highly gifted woman … a wonderful entertainer.” —<i>The New Yorker</i></p>
<p class="normal1">“One of the most gifted writers of comedy in the civilized world today.” —<i>Chicago Daily News</i></p>
<p class="normal1">“[Sharp’s] dialogue is brilliant, uncannily true. Her taste is excellent; she is an excellent storyteller.” —Elizabeth Bowen</p>
<p class="fm-p">Britannia Mews</p>
<p class="normal1">“As an artistic achievement … first-class, as entertainment … tops.” —<i>The Boston Globe</i></p>
<p class="fm-p">The Eye of Love</p>
<p class="normal1">“A double-plotted … masterpiece.” —John Bayley, <i>Guardian Books of the Year</i></p>
<p class="fm-p">Martha, Eric, and George</p>
<p class="normal1">“Amusing, enjoyable, Miss Sharp is a born storyteller.” —<i>The Times</i> (London)</p>
<p class="fm-p">The Gypsy in the Parlour</p>
<p class="normal1">“Unforgettable … There is humor, mystery, good narrative.” —<i>Library Journal</i></p>
<p class="fm-p">The Nutmeg Tree</p>
<p class="normal1">“A sheer delight.” —New York Herald Tribune</p>
<p class="fm-p">Something Light</p>
<p class="normal1">“Margery Sharp has done it again! Witty, clever, delightful, entertaining.” —<i>The Denver Post</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?b77e319a